<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton icon="fa-plus" v-on:click="onClickButton" />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <CostMaterialTransportationList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import CostMaterialTransportationList from "@/components/reports/costmaterialtransportation/CostMaterialTransportationList";
import ActionButton from "@/components/button/ActionButton";

export default {
  name: "CostMaterialTransportationLists",

  components: {
    PageTitle,
    PageRowWrapper,
    CostMaterialTransportationList,
    ActionButton,
  },

  methods: {
    onClickButton(e) {
      this.$router.push({ name: "addcostmaterialtransportation" });
    },
  },
};
</script>
